import React from 'react';

function Spinner() {
    return <span className="spinner" aria-hidden="true" />;
}

export default Spinner;
